import * as React from 'react';
import { observer } from 'mobx-react';
import './errorStep.module.scss';

type Props = {
    errorMessage: string;
};

@observer
export class ErrorStep extends React.Component<Props> {
    render() {
        const { errorMessage } = this.props;
        return (
            <div>
                <div styleName="error-box">
                    申し込みを正しくお受付できませんでした。<br />
                    原因: <span>{errorMessage}</span>
                </div>
            </div>
        );
    }
}
